import {CurrentProjectResource} from 'common/report/model-resources/projects';
import {contextify} from 'common/util/react';

const context = contextify<CurrentProjectResource>();

export const CurrentProjectProvider = context.Provider;
export const CurrentProjectConsumer = context.Consumer;
